module.exports = __webpack_public_path__ + "img/icon-garden.b5326b97.svg";